import { CampaignIDs } from '@energy-retailer/constants';

import { getIsEvPlan } from '../get-is-ev-plan';

import type { CampaignID } from '@energy-retailer/constants';

const getHasCartConflicts = ({
  promoId,
  electricityPlanSlug,
}: {
  promoId?: CampaignID;
  electricityPlanSlug: string | null;
}): boolean => {
  if (!promoId) {
    return false;
  }

  const isEvPlanSelected = getIsEvPlan(electricityPlanSlug);

  if ((promoId as CampaignID) === CampaignIDs.CanstarBlue && isEvPlanSelected) {
    return true;
  }

  if (
    (promoId as CampaignID) === CampaignIDs.SwitchYourMates &&
    electricityPlanSlug === 'switch-saver'
  ) {
    return true;
  }

  return false;
};

export { getHasCartConflicts };
